import ENIcon from "@/assets/icons/en.svg"
import VIIcon from "@/assets/icons/vi.svg"
import { LanguageContext } from "@/providers/language"
import { Button, Stack } from "@mui/material"
import { useRouter } from "next/router"
import { FC, memo, useContext } from "react"

const languages: { [key: string]: { text: string; icon: any; short: string } } = {
  vi: {
    text: "vietnamese",
    icon: VIIcon,
    short: "VI",
  },
  en: {
    text: "english",
    icon: ENIcon,
    short: "EN",
  },
}

const LanguageMenu: FC = () => {
  const { handleChangeLanguage } = useContext(LanguageContext)

  const router = useRouter()
  const handleSelectLanguage = (lang: string) => {
    handleChangeLanguage(lang)
  }

  return (
    <Stack direction='row' className='bg-secondary rounded p-[2px]' data-testid='language-menu'>
      {Object.keys(languages).map((key) => (
        <Button
          key={key}
          onClick={() => handleSelectLanguage(key)}
          className={`px-[6px] py-1 min-w-[30px] text-[13px] rounded ${router.locale === key ? "bg-white hover:bg-white text-primary font-medium" : "text-neutral-500"}`}
          data-testid={`language-menu-${key}`}
        >
          {languages[key].short}
        </Button>
      ))}
    </Stack>
  )
}
export default memo(LanguageMenu)
